// src/components/StatusFooter/StatusFooter.jsx
import React from 'react';
import { useHealth } from '../../context/HealthContext';
import styles from './StatusFooter.module.css';
import buildInfo from '../../config/version';

// Helper function
const getStatusColor = (condition, styles) => {
  if (condition === true || condition === 'healthy' || condition === 'enabled') {
    return styles.statusGreen;
  }
  if (condition === false || condition === 'unhealthy' || condition === 'disabled') {
    return styles.statusRed;
  }
  return styles.statusYellow;
};

const StatusFooter = () => {
  const status = useHealth();
  console.debug('👣 StatusFooter CURRENT STATE:', {
    aiEnabled: status.ai.enabled,
    aiConfigured: status.ai.configured,
    aiLastCheck: status.ai.lastCheck,
    backendHealthy: status.backend.healthy,
    backendLastCheck: status.backend.lastCheck,
    backendError: status.backend.error,
    time: new Date().toISOString()
  });
  return (
    <footer className={styles.statusFooter}>
      {/* LEFT: Status Indicators */}
      <div className={styles.statusItems}>
        <div className={styles.statusItem}>
          <span className={styles.statusLabel}>Network:</span>
          <span className={`${styles.statusDot} ${getStatusColor(status.network, styles)}`} />
          <span className={styles.statusValue}>{status.network ? 'Online' : 'Offline'}</span>
        </div>
        
        <div className={styles.statusItem}>
          <span className={styles.statusLabel}>Backend:</span>
          <span className={`${styles.statusDot} ${getStatusColor(status.backend.healthy, styles)}`} />
          <span className={styles.statusValue}>
             {!status.backend.checked ? 'Preflight' : 
            status.backend.healthy ? 'Healthy' : 'Unhealthy'}
          </span>
        </div>
        
        <div className={styles.statusItem}>
          <span className={styles.statusLabel}>AI Copilot:</span>
          <span className={`${styles.statusDot} ${getStatusColor(status.ai.enabled, styles)}`} />
           <span className={styles.statusValue}>
             {!status.ai.checked ? 'Preflight' : 
            status.ai.enabled ? 'Enabled' : status.ai.configured ? 'Configured' : 'Disabled'}
          </span>
        </div>
      </div>

      {/* RIGHT: Footer Info */}
      <div className={styles.footerInfo}>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} OnServ Trader v{buildInfo.version}-{buildInfo.commitHash?.substring(0, 7) || 'dev'}
        </span>
        <div className={styles.links}>
          <a href="/privacy" className={styles.link}>Privacy</a>
          <span className={styles.separator}>•</span>
          <a href="/terms" className={styles.link}>Terms</a>
          <span className={styles.separator}>•</span>
          <a href="https://onserv.com/" target="_blank" rel="noopener noreferrer" className={styles.link}>
            Corporate
          </a>
        </div>
        <span className={styles.time}>
          {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
        </span>
        {status.ai.error && (
          <span className={styles.errorHint} title={status.ai.error}>⚠️</span>
        )}
      </div>
    </footer>
  );
};

export default StatusFooter;